/**
 * @module actions/overview
 */
import axios from 'axios'
import {
  API_URL,
  SET_DELIVERY_STATUS,
  SET_PICKUP_STATUS,
  SET_PRODUCTION_STATUS
} from '../constants'

/**
 * @description Get the productions status of all orders
 * @return {Promise} Axios promise
 */
export function getProductionStatus () {
  let url = API_URL + '/overview/0'
  return dispatch => {
    return axios.get(url).then(res => {
      dispatch(setProductionStatus(res.data))
      return res
    })
  }
}

/**
 * @description Get the pickup status of all orders
 * @return {Promise} Axios promise
 */
export function getPickupStatus () {
  let url = API_URL + '/overview/1'
  return dispatch => {
    return axios.get(url).then(res => {
      dispatch(setPickupStatus(res.data))
      return res
    })
  }
}

/**
 * @description Get the delivery status of all orders
 * @return {Promise} Axios promise
 */
export function getDeliveryStatus () {
  let url = API_URL + '/overview/2'
  return dispatch => {
    return axios.get(url).then(res => {
      dispatch(setDeliveryStatus(res.data))
      return res
    })
  }
}

export function setDeliveryStatus (data) {
  return dispatch => {
    dispatch({
      type: SET_DELIVERY_STATUS,
      data
    })
  }
}

export function setPickupStatus (data) {
  return dispatch => {
    dispatch({
      type: SET_PICKUP_STATUS,
      data
    })
  }
}

export function setProductionStatus (data) {
  return dispatch => {
    dispatch({
      type: SET_PRODUCTION_STATUS,
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/overview.js